import { get, post, deleteFun, put } from '@/utils/request.js';

// 字典管理

/**
 * 字典列表
 */
export function getDictList(params) {
    return get('/mpp/dict/findList', params);
}

/**
 * 字典详情
 * dictId
 */
export function getDictById(params) {
    return get('/mpp/dict/get', params);
}

/**
 * 新增字典
 * dictType 字典类型
 * dictName 字典描述
 */
export function addDict(params) {
    return post('/mpp/dict/add', params);
}

/**
 * 新增字典
 * dictType 字典类型
 * dictName 字典描述
 */
export function editDict(params) {
    return post('/mpp/dict/edit', params);
}

/**
 * 删除字典
 * str 字典id,支持批量删除
 */
export function deleteDict(params) {
    return deleteFun('/mpp/dict/delete', params);
}

/*
字典内容列表
*/
export function getDictValue(params) {
    return get('/mpp/dict/findValue', params);
}
/**
 * 获取字典内容详情
 */
export function findDictValue(params){
    return get('/mpp/dict/getValue', params);
}

/**
 * 新增字典内容
 */
 export function saveDictValue(params){
    return post('/mpp/dict/addValue', params);
 }
 
/**
 * 修改字典内容
 */
 export function editDictValue(params){
    return post('/mpp/dict/editValue', params);
 }
